import * as FormatError from "./format-error.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class Logger {

    /** @type {{time: Date, level: string, title: string, message: string}[]} */
    #entries = [];
    /** @type {function()[]} */
    #onUpdated = [];

    /**
     *
     * @param level {string}
     * @param title {string}
     * @param e {*}
     */
    add(level, title, e) {
        this.#entries.push({
            time: new Date(),
            level: level,
            title: title,
            message: FormatError.format(e)
        });
        for (let handler of this.#onUpdated) {
            handler();
        }
    }

    /**
     *
     * @param title {string}
     * @param e {*}
     */
    addError(title, e) {
        this.add('error', title, e);
    }

    /**
     *
     * @param title {string}
     * @param e {*}
     */
    addInfo(title, e) {
        this.add('info', title, e);
    }

    /**
     *
     * @return {{time: Date, level: string, title: string, message: string}[]}
     */
    getEntries() {
        return this.#entries;
    }

    /**
     *
     * @param handler {function()}
     */
    addOnUpdated(handler) {
        this.#onUpdated.push(handler);
    }
}
